import PropTypes from "prop-types"
import classnames from "classnames"
import { useBgColorContext } from "./context"

import LearnMoreButton from "shared/components/learn_more_button"
import ReturnButton from "./return_button"
import { trackClickCancelButton } from "./utils/telemetry"
import ProDiyBanner from "./pro_diy_banner"
import ProDiyFooter from "./pro_diy_footer"
import { steps } from "./steps"
import colors from "foundation/_colors_export.scss?variables"

import "./header.scss"

export const Header = ({
  editing,
  backButtonTarget,
  title,
  updateLoading,
  user,
  step,
  showingCheckoutModal,
  showUpgradeModal,
}) => {
  const bgColor = useBgColorContext()
  const bgOnColor = bgColor !== "white"
  const color = bgOnColor ? "white" : colors.primaryTextColor
  const initialStep = step === steps.INITIAL

  const onReturn = () => {
    if (initialStep && editing) {
      window.history.back()
    } else if (initialStep) {
      updateLoading(true)
      trackClickCancelButton()
      window.location = "/my_applets"
    } else {
      backButtonTarget()
    }
  }

  const classes = classnames("diy-header", {
    "on-color": bgOnColor,
  })

  const userWithUnlimitedApplets = ["pro", "legacy_pro"].includes(user.tier)
  const userUnderQuota =
    !userWithUnlimitedApplets && user.appletQuota.remaining > 0
  const showUpsell = initialStep && userUnderQuota && !user.isTrialing

  return (
    <>
      <header style={{ backgroundColor: bgColor }} styleName={classes}>
        <ReturnButton
          onClick={onReturn}
          initialStep={initialStep}
          color={color}
        />
        <h1 style={{ color }}>{title}</h1>
        {user.tier == "free" && (
          <LearnMoreButton
            url="https://ift.tt/applets-101"
            location="diy_composer"
            darkHeader={bgOnColor}
            title="Learn more: Best Practices - Applets 101"
          />
        )}
      </header>
      {showUpsell && !showingCheckoutModal && (
        <>
          <ProDiyBanner onClick={showUpgradeModal} userTier={user.tier} />
          <ProDiyFooter
            cookieName={`hide_pro_footer_${user.login}`}
            onClick={showUpgradeModal}
            userTier={user.tier}
          />
        </>
      )}
    </>
  )
}

Header.propTypes = {
  editing: PropTypes.bool.isRequired,
  backButtonTarget: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  updateLoading: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  showingCheckoutModal: PropTypes.bool.isRequired,
  step: PropTypes.number.isRequired,
  showUpgradeModal: PropTypes.func.isRequired,
}

Header.defaultProps = {
  title: "Create",
  backButtonTarget: () => {},
}

export default Header
